<script>
export default {
   name: 'aboutContent',
   props: {
      classes: String,
      title: String,
      content: Object,
      showLabel: { type: Boolean, default: true },
   },
   components: {},
   data() {
      return {}
   },
   computed: {},
   methods: {},
   mounted() {},
}
</script>

<template>
   <section :class="['about-content', classes]">
      <div class="left">
         <!-- header -->
         <h1>{{ title }}</h1>

         <div v-html="content.about"></div>
      </div>

      <!-- right panel -->
      <div class="right">
         <p class="label" v-if="showLabel">Get In Touch</p>
         <div v-html="content.contact"></div>
      </div>
   </section>
</template>
